import { render, staticRenderFns } from "./zbNotice.vue?vue&type=template&id=ce2f4b84&scoped=true"
import script from "./zbNotice.vue?vue&type=script&lang=js"
export * from "./zbNotice.vue?vue&type=script&lang=js"
import style0 from "./zbNotice.vue?vue&type=style&index=0&id=ce2f4b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f4b84",
  null
  
)

export default component.exports